var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAccount(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 30,
    viewBox: "0 0 34 30",
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#525253",
    strokeWidth: 1.4,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.51 23.798c-4.178-.825-4.436-1.857-4.436-2.682v-1.032a7.273 7.273 0 002.063-3.61c1.29 0 2.063-1.548 2.063-3.095 0-.413 0-2.063-1.032-2.063C22.748 3.836 15.217 1 9.853 4.61c-2.27 0-2.889 3.404-2.064 6.705-1.031 0-1.031 1.65-1.031 2.063 0 1.547.774 3.095 2.063 3.095a7.324 7.324 0 002.063 3.61v1.032c0 .825-.258 1.857-4.436 2.682-4.177.825-4.848 4.539-4.848 4.539h24.758s0-3.56-4.849-4.54zM24.295 9.768h8.252m-8.252-4.126h8.252M22.232 1.516h10.315"
  }))));
}

export default SvgIconAccount;